<template>
  <form @submit.prevent="emitSave" id="GimObjectTableAddEditDialog">
    <h4 class="mb-4">{{ 'ADD' | translate }}</h4>
    <div class="alert alert-danger alert-dismissible mt-5" v-if="error" id="GimObjectTableAddEditDialog-errorDiv">
      {{ error }}
      <button type="button" class="close" @click="dismissAlertError()" aria-label="Close"
        id="GimObjectTableAddEditDialog-closeButton">
        <span aria-hidden="true" id="GimObjectTableAddEditDialog-closeButton-span">&times;</span>
      </button>
    </div>
    <div class="alert alert-danger alert-dismissible mt-5" v-if="showConfirmDialog"
      id="GimObjectTableAddEditDialog-alert">
      Do you want to update the existing file?
      <button type="button" class="btn btn-success" @click="confirm()" aria-label="Close"
        id="GimObjectTableAddEditDialog-yesButton">Yes</button>
      <button type="button" class="btn btn-link" @click="cancel()" aria-label="Close"
        id="GimObjectTableAddEditDialog-noButton">No</button>
    </div>
    <div class="form-group" id="GimObjectTableAddEditDialog-formGroup-Naam">
      <label>{{ 'GIM_OBJECT_NAME' | translate() }} <span class="asterisk">*</span></label>
      <input type="text" class="form-control form-control-sm" v-model="fileName" disabled
        id="GimObjectTableAddEditDialog-formGroup-Naam-input">
    </div>
    <div class="form-group" id="GimObjectTableAddEditDialog-formGroup-Omschrijving">
      <label>{{ 'GIM_OBJECT_DESCRIPTION' | translate() }} <span class="asterisk">*</span></label>
      <div class="custom-file" id="GimObjectTableAddEditDialog-formGroup-CustomFile">
        <input ref="importFile" type="file" class="custom-file-input" id="import_file" name="import_file"
          @click="resetImportFile" @change="selectFile" required>
        <label class="custom-file-label" for="import_file">
          {{ (file && file.name) ? file.name : 'UPLOAD_FILE' | translate }}
        </label>
      </div>
    </div>
    <div class="mt-4 text-right" id="GimObjectTableAddEditDialog-buttons">
      <button class="btn btn-link" type="button" @click="emitClose" id="GimObjectTableAddEditDialog-closeButton">{{ 'CLOSE' | translate }}</button>
      <button class="btn btn-primary" type="button" @click="saveOrUpdate" :disabled="!isFormValid"
        id="GimObjectTableAddEditDialog-addButton">{{ 'ADD' | translate }}</button>
    </div>
    <div class="cm-container">
      <div class="cm-loader" v-if="loaded">
        <custom-spinner></custom-spinner>
      </div>
    </div>
  </form>
</template>

<script>
import RestService from '../../../service/RestService.js';
import CustomSpinner from '../../CustomSpinner.vue';

export default {
  components: { CustomSpinner },
  props: ['edited', 'loaded', 'errorMessage'],
  data() {
    return {
      rest: this.initRestService(),
      file: {},
      error: '',
      fileName: '',
      showConfirmDialog: false
    };
  },
  computed: {
    isFormValid() {
      return !!this.file.name; // Ensures that a file has been selected
    }
  },
  methods: {
    confirm() {
      this.emitSave();
      this.showConfirmDialog = false;
    },
    cancel() {
      this.showConfirmDialog = false;
      this.emitClose();
    },
    resetImportFile() {
      this.$refs.importFile.value = null;
      this.file = {};
      this.fileName = '';
    },
    saveOrUpdate() {
      if (this.edited) {
        this.showConfirmDialog = true;
      } else {
        this.emitSave();
        this.showConfirmDialog = false;
      }
    },
    initRestService() {
      return new RestService();
    },
    emitSave() {
      if (this.file && this.file.name) {
        const formData = new FormData();
        formData.append('gimObject_file', this.file);
        formData.append('file_name', this.fileName);
        this.$emit(this.edited ? 'update' : 'save', formData);

        // Clear form data after submission
        this.file = {};
        this.fileName = '';
        this.error = '';
        this.$emit('clearErrorMessage', this.error);
      } else {
        this.error = 'Please select a file to upload.';
      }
    },
    emitClose() {
      this.file = {};
      this.fileName = '';
      this.showConfirmDialog = false;
      this.error = '';
      this.$emit('close');
    },
    selectFile: function (evt) {
      this.file = evt.target.files[0];
      this.fileName = this.file.name;
    },
    dismissAlertError: function () {
      this.error = '';
    }
  },
  watch: {
    edited(newVal) {
      if (newVal) {
        this.file = { ...newVal };
        this.fileName = newVal.fileName || '';
      } else {
        this.file = {};
        this.fileName = '';
      }
    },
    errorMessage(val) {
      this.error = val || '';
    }
  }
};
</script>

<style lang="scss" scoped>
.asterisk {
  color: $danger;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/gim-object/GimObjectAddEditDialog.vue